import { render, staticRenderFns } from "./IconDelivery.vue?vue&type=template&id=666cb9b2"
import script from "./IconDelivery.vue?vue&type=script&lang=js"
export * from "./IconDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports